import { Badge } from "../components/ui/badge";

const MAP = {
  draft: { label: "Draft", cls: "bg-zinc-100 text-zinc-700 border-zinc-300" },
  sent: { label: "Sent", cls: "bg-blue-50 text-blue-700 border-blue-300" },
  accepted: { label: "Accepted", cls: "bg-green-50 text-green-700 border-green-300" },
  rejected: { label: "Rejected", cls: "bg-red-50 text-red-700 border-red-300" },
};

export default function StatusBadge({ status }) {
  const s = MAP[status] || MAP.draft;
  return (
    <Badge data-testid={`status-${status}`} className={`rounded-none border font-mono text-[10px] uppercase tracking-widest ${s.cls}`}>
      {s.label}
    </Badge>
  );
}
